export const getPanelUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    // Remove www if present
    const baseDomain = hostname.replace(/^www\./, "");

    return `${window.location.protocol}//panel.${baseDomain}/`;
  }

  return "";
};